__turbopack_context__.v({
  "arrow": "related-products-module__t5FFfq__arrow",
  "arrowNext": "related-products-module__t5FFfq__arrowNext",
  "arrowPrev": "related-products-module__t5FFfq__arrowPrev",
  "blurLayer": "related-products-module__t5FFfq__blurLayer",
  "card": "related-products-module__t5FFfq__card",
  "carousel": "related-products-module__t5FFfq__carousel",
  "image": "related-products-module__t5FFfq__image",
  "imageActive": "related-products-module__t5FFfq__imageActive",
  "info": "related-products-module__t5FFfq__info",
  "item": "related-products-module__t5FFfq__item",
  "mobile": "related-products-module__t5FFfq__mobile",
  "mobileCard": "related-products-module__t5FFfq__mobileCard",
  "mobileGrid": "related-products-module__t5FFfq__mobileGrid",
  "mobileImage": "related-products-module__t5FFfq__mobileImage",
  "mobileImageWrap": "related-products-module__t5FFfq__mobileImageWrap",
  "mobileInfo": "related-products-module__t5FFfq__mobileInfo",
  "mobileName": "related-products-module__t5FFfq__mobileName",
  "mobilePrice": "related-products-module__t5FFfq__mobilePrice",
  "mobileTitle": "related-products-module__t5FFfq__mobileTitle",
  "name": "related-products-module__t5FFfq__name",
  "price": "related-products-module__t5FFfq__price",
  "size": "related-products-module__t5FFfq__size",
  "sizes": "related-products-module__t5FFfq__sizes",
  "tint": "related-products-module__t5FFfq__tint",
  "title": "related-products-module__t5FFfq__title",
  "track": "related-products-module__t5FFfq__track",
  "viewport": "related-products-module__t5FFfq__viewport",
  "window": "related-products-module__t5FFfq__window",
});
